import { PropTypes } from 'base/react-libs';
import { PageHeader } from '@evertrue/et-components';
import Resources from './resources';
import Metrics from './metrics';
import Upcoming from './upcoming';
import NextSteps from './next-steps/next-steps';

const getTitle = (user = {}) => {
  if (!user || !user?.name) return 'Welcome back!';
  const { name = '' } = user;
  const firstName = name.split(' ')[0];
  return `Welcome, ${firstName}!`;
};

const HomepageMainContent = ({
  org = {},
  user = {},
  todayJourneyCount,
  todayTaskCount,
  nextFiveDaysCounts,
  loadingJourneysTodayCount,
  loadingTasksTodayCount,
  loadingNextFiveCounts,
  futureJourneyTimeout,
  inProgressJourneyTimeout,
  businessDaysUntilFutureTimeout,
  tripsAndMeetingDetails,
  tripsAndMeetingDetailsForNextFive,
  optionalStateManagementFunction = () => {},
}) => {
  return (
    <>
      <div className="homepage-title-containter">
        <PageHeader title={getTitle(user)} className="homepage-title" />
      </div>
      <div className="homepage-main-content">
        <Upcoming
          todayJourneyCount={todayJourneyCount}
          todayTaskCount={todayTaskCount}
          nextFiveDaysCounts={nextFiveDaysCounts}
          loadingJourneysTodayCount={loadingJourneysTodayCount}
          loadingTasksTodayCount={loadingTasksTodayCount}
          loadingNextFiveCounts={loadingNextFiveCounts}
          businessDaysUntilFutureTimeout={businessDaysUntilFutureTimeout}
          futureJourneyTimeout={futureJourneyTimeout}
          inProgressJourneyTimeout={inProgressJourneyTimeout}
          tripsAndMeetingDetails={tripsAndMeetingDetails}
          tripsAndMeetingDetailsForNextFive={tripsAndMeetingDetailsForNextFive}
          optionalStateManagementFunction={optionalStateManagementFunction}
        />
        <NextSteps user={user} org={org} />
        <Metrics />
        <Resources />
      </div>
    </>
  );
};

HomepageMainContent.propTypes = {
  org: PropTypes.object,
  user: PropTypes.object,
  todayJourneyCount: PropTypes.object,
  todayTaskCount: PropTypes.object,
  nextFiveDaysCounts: PropTypes.array,
  loadingJourneysTodayCount: PropTypes.bool,
  loadingTasksTodayCount: PropTypes.bool,
  loadingNextFiveCounts: PropTypes.bool,
  businessDaysUntilFutureTimeout: PropTypes.number,
  futureJourneyTimeout: PropTypes.object,
  inProgressJourneyTimeout: PropTypes.object,
  optionalStateManagementFunction: PropTypes.func,
  tripsAndMeetingDetails: PropTypes.any,
  tripsAndMeetingDetailsForNextFive: PropTypes.object,
};

export default HomepageMainContent;
